// extracted by mini-css-extract-plugin
export default {"loadingCircle":"Loading_loadingCircle__sfgQG","rotating":"Loading_rotating__KbPpk"};